// @flow
import * as React from 'react'
import { keys, map, throttle } from 'lodash/fp'

import StyledTable from './Table'
import Pagination from './Pagination'
import { formatSortState } from './convertSortState'
import styled from 'styled-components'

class Table extends React.PureComponent {
  static defaultProps = {
    defaultPageSize: 50,
    minColumnWidth: 50,
    addAriaLabelToHeader: false,
  }

  constructor(props) {
    super(props)
    this.initialRowIds = map('task', props.data)
  }

  state = {
    resized: [],
  }

  onSortedChange = (_, { id }) => {
    const { order: prevOrder, onSortedChange } = this.props

    if (!id) {
      throw new Error(
        'onSortedChange: no column id. Did you forget to give it one?'
      )
    }
    if (!onSortedChange) {
      throw new Error(
        'Table: must provide onSortedChange if any columns are sortable.'
      )
    }
    if (!prevOrder) {
      throw new Error('Table: must provide order if any columns are sortable')
    }

    const prevSortColumn = keys(prevOrder)[0]

    let newOrder
    if (prevSortColumn !== id) {
      newOrder = {
        [id]: 'asc',
      }
    } else if (prevOrder[prevSortColumn] === 'asc') {
      newOrder = {
        [id]: 'desc',
      }
    } else newOrder = {}

    onSortedChange(newOrder)
  }

  onResizedChange = throttle(50, (newResized) => {
    const resizedState = map(
      (column) => ({
        ...column,
        value: Math.max(column.value, this.props.minColumnWidth),
      }),
      newResized
    )
    this.setState({ resized: resizedState })
  })

  renderColumnHeader = (column) => {
    const order = this.props.order

    if (column.sortable == null || order == null || column.sortable === false) {
      return column.Header
    }

    const columnId = column.id
    const columnHeader = column.Header
    let ariaLabel = ''

    const currentOrderColumnId =
      Object.keys(order).length == 0 ? null : Object.keys(order)[0]
    const currentOrderDirection =
      Object.keys(order).length == 0 ? null : order[currentOrderColumnId]

    if (currentOrderColumnId === columnId) {
      if (currentOrderDirection == 'asc') {
        ariaLabel = `${columnHeader} Posortowane rosnąco`
      } else {
        ariaLabel = `${columnHeader} Posortowane malejąco`
      }
    } else {
      ariaLabel = `${columnHeader} Nieposortowane`
    }

    return (
      <ColumnHeaderButton aria-label={ariaLabel}>
        {column.Header}
      </ColumnHeaderButton>
    )
  }

  render() {
    const {
      total,
      order,
      onSortedChange,
      noDataText,
      columns,
      addAriaLabelToHeader,
      ...props
    } = this.props

    const showPagination =
      total !== undefined ? props.defaultPageSize < total : false
    const pages =
      total !== undefined ? Math.ceil(total / props.defaultPageSize) : undefined

    const normalizedColumns = map(
      (col) => ({
        Cell: DefaultCell,
        ...col,
        Header: this.renderColumnHeader(col),
      }),
      columns
    )

    return (
      <div
        ref={(element) => {
          this.table = element
        }}
      >
        <StyledTable
          PaginationComponent={Pagination}
          noDataText={noDataText || 'Brak danych'}
          manual
          showPagination={showPagination}
          pages={pages}
          showPageSizeOptions={false}
          resized={this.state.resized}
          minRows={0}
          sorted={order ? formatSortState(order) : undefined}
          previousText="Wstecz"
          nextText="Dalej"
          pageText="Strona"
          ofText="z"
          onSortedChange={this.onSortedChange}
          onResizedChange={this.onResizedChange}
          columns={normalizedColumns}
          {...props}
        />
      </div>
    )
  }
}

const DefaultCell = (props) => <span role="gridcell">{props.value}</span>

const ColumnHeaderButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  outline-offset: -2px;
`

export default Table
